// 订单排产
<template>
  <div style="position: relative">
    <el-form
      ref="formSysPost"
      :model="formSysPost"
      label-width="100px"
      :size="defaultFormItemSize"
      label-position="right"
      @submit.native.prevent
    >
      <filter-box :item-width="350">
        <!-- <el-form-item label="岗位名称" prop="formFilter.postName">
          <el-input
            class="filter-item"
            v-model="formSysPost.formFilter.postName"
            :clearable="true"
            placeholder="岗位名称"
          />
        </el-form-item>
        <el-button
          slot="operator"
          type="default"
          :plain="true"
          :size="defaultFormItemSize"
          @click="onReset"
          >重置</el-button
        >
        <el-button
          slot="operator"
          type="primary"
          :plain="true"
          :size="defaultFormItemSize"
          @click="refreshFormSysPost(true)"
          >查询</el-button
        > -->
        <!-- <el-button
          slot="operator"
          type="primary"
          size="small"
          @click="addItem()"
        >
          新建
        </el-button> -->
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <Table
          :tableData="tableData"
          :loading="false"
          :operateWidth="160"
          :tableHeader="tableHeader"
          :pagination="pagination"
          @pagination="changePagination"
          :slotArr="slotArr"
        >
          <!-- table 操作栏 -->
          <template slot="operation" slot-scope="scope">
            <el-button @click.stop="editItem(scope.row)" type="text">
              编辑
            </el-button>
            <el-button
              class="table-btn delete"
              @click.stop="deleteItem(scope.row)"
              type="text"
            >
              删除
            </el-button>
          </template>
        </Table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import rules from "@/utils/validate.js";
import {
  DropdownWidget,
  TableWidget,
  UploadWidget,
  ChartWidget,
} from "@/utils/widget.js";
import AddOrEdit from "./indexInfo.vue";
import Table from "../../components/MyTable/index.vue";

export default {
  name: "LabelModel",
  props: {},
  components: {
    AddOrEdit,
    Table,
  },
  // mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data() {
    return {
      showSearch: true,
      slotArr: [
        { slotname: "headBox" },
        { slotname: "searchBox", className: "search_box" },
        { slotname: "btnBox", className: "" },
      ],

      tableData: [],

      tableHeader: [],
      // table 筛选条件
      tableParams: {},
      tableSearch: [],

      pagination: {
        size: 10,
        total: 0,
        page: 1,
      },
      STATUS: {
        0: "建单",
        1: "开立",
        2: "投产",
        3: "完结",
        5: "发货",
      },

      formSysPost: {
        formFilter: {
          postName: undefined,
        },
        formFilterCopy: {
          postName: undefined,
        },
        sysPost: {
          impl: new TableWidget(
            this.loadSysPostWidgetData,
            this.loadSysPostVerify,
            true,
            false,
            "level",
            1
          ),
        },
        isInit: false,
      },
      typeObj: {
        1: "原材料",
        2: "模具",
        3: "成品",
      },
      modelTypeArr: [
        { label: "原材料", value: 1 },
        { label: "模具", value: 2 },
        { label: "成品", value: 3 },
      ],

      dialogVisible: false,
      title: 1, // 1、新增 2、编辑 3、详情
      row: {},
    };
  },
  methods: {
    // 筛选 页数为 1
    onSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },
    // 页数切换
    changePagination(val) {
      this.pagination = {
        ...this.pagination,
        ...val,
      };
      this.getTableData();
    },
    async getTableData() {
      let { data } = await this.$api.getWorkOrderSchedulingPage({
        pageNum: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.tableData = data.list;
      this.pagination.total = data.total;
    },
    // 重置
    reset() {
      this.tableParams = {};
      this.getTableData();
    },
  },
  mounted() {
    this.tableHeader = [
      { label: "排产序号", prop: "index" },
      { label: "工单编号", prop: "id" },
      // { label: "销售订单号", prop: "batchNo" },
      // { label: "本批数量", prop: "amount" },
      // { label: "产品名称", prop: "productName" },
      // { label: "产品名称", prop: "productNametwo" },
      // { label: "规格型号", prop: "productSpec" },
      // { label: "规格型号", prop: "productModel" },
      {
        label: "单据状态",
        prop: "status",
        render: (h, params) => {
          return <p>{this.STATUS[params.row.status]}</p>;
        },
      },
      { label: "经手人", prop: "showName" },
      { label: "交付状态", prop: "overdue" },
      { label: "交付日期", prop: "dueTime" },
    ];

    this.getTableData();
  },
  activated() {
    this.getTableData();
  },
  watch: {},
};
</script>
